module.exports = __webpack_public_path__ + "img/p76.af0aea82.png";